import { Col, Container, Row } from "react-bootstrap";
import Navbar from "../../components/Navbar/Navbar"
import Footer from '../../components/Footer/Footer';
import videoFabrica from '../../assets/aba/Pulmón más llenadora.mp4';
import ReactPlayer from 'react-player';

import ecologic from '../../assets/aba/ecologic.png';
import { useTranslation } from "react-i18next";

function EcologicalCommitment() {

    const { i18n, t } = useTranslation();

    return (
        <Container>
            <Row>
                <Col md={6} style={{ padding: '10px' }}>
                    <ReactPlayer 
                        url={videoFabrica} 
                        controls={true}
                        width='100%'
                        height='800px'
                        loop={true}
                    ></ReactPlayer> 
                </Col>
                <Col style={{textAlign:'justify'}} md={6}>
                    <Row> 
                        <Col md={12}><h1 style={{marginTop:'80px'}}>{t('CaringForTheEnvironment')}</h1></Col>                  
                        <Col md={12}>
                            <p style={{marginTop:'30px'}}> 
                                {t('CaringForTheEnvironmentText')}
                            </p>
                        </Col>
                        <Col md={12} style={{ textAlign: 'center', marginTop: '15px'}}>
                            <img src={ecologic} width='30%' height='90%'>
                            </img>
                        </Col>
                    </Row>

                </Col>
            </Row>
        </Container>
    );
}

export default EcologicalCommitment;